import React from 'react';
import { Link } from 'react-router-dom';

import { FormattedMessage } from '../../util/reactIntl';

import logoFooterPng from '../../assets/logo-footer.png';
import css from './FooterContainer.module.css';

// Uroborox custom footer — ignores Console footer asset
const UroboroxFooter = () => (
  <footer className={css.root}>
    <div className={css.inner}>
      <div className={css.brand}>
        <img src={logoFooterPng} alt="Uroborox" className={css.logo} />
        <p className={css.slogan}>
          <FormattedMessage id="FooterContainer.slogan" />
        </p>
      </div>
      <nav className={css.links}>
        <Link to="/terms-of-service" className={css.link}>
          <FormattedMessage id="FooterContainer.terms" />
        </Link>
        <Link to="/privacy-policy" className={css.link}>
          <FormattedMessage id="FooterContainer.privacy" />
        </Link>
        <Link to="/contacto" className={css.link}>
          <FormattedMessage id="FooterContainer.contact" />
        </Link>
      </nav>
      <span className={css.copy}>
        <FormattedMessage id="FooterContainer.copyright" />
      </span>
    </div>
  </footer>
);

const FooterComponent = () => {
  return <UroboroxFooter />;
};

export default FooterComponent;
